import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/isSameYear/index.js';

var require$$51 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$51 as default };
